import * as React from 'react';
import { Button, Input, Modal, Form, Label, Tab, Icon, Dropdown } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import ReactTable from 'react-table';
// import 'react-table/react-table.css';
import * as moment from 'moment';
// @ts-ignore
// import withFixedColumns from 'react-table-hoc-fixed-columns';
// import 'react-table-hoc-fixed-columns/lib/styles.css'; // important: this line must be placed after react-table css import
import CustomPagination from '../../sys/pagination';
import OAuth, { OAuthClientStatus } from '../../api';
import { default as Renderers } from '../../sys/columns';
import * as ReactTooltip from 'react-tooltip';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-table/react-table.css';
// const ReactTableFixedColumns = withFixedColumns(ReactTable);
const FontAwesome = require('react-fontawesome');
const fileDownload = require('js-file-download');

class State {
    file: any;
    sysName ?: string;
    showImportModal ?: boolean;
    showDeleteModal ?: boolean;
    showResultModal ?: boolean;
    deleteAll ?: boolean;
    name ?: string;
    modalText: string;
    dailyData ?: any;
    eventData ?: any;
    unFilteredDailyData ?: any;
    unFilteredEventData ?: any;
    indices ?: any;
    timeTicks: number;
    renderingComplete ?: boolean;
    fileName ?: string;
    creationTime ?: string;
    minuteOfDay ?: number;
    secIntervalOfDay ?: number;
    intervalOfDay ?: number;
    filteredDailyData ?: boolean;
    filteredEventData ?: boolean;
    assetFilter?: string;
    eventFilter?: string;
    exportData?: string;
    revision?: string;
    dailyTabSelected: boolean;
    startDateFilter?: any;
    selectedDay ?: any;
    defaultSelectedDay ?: any;
    dayOfWeek ?: any;
    startTicks: number;
    endTicks: number;
}

interface Props {
    refresh ?: number;
}

export default class SchedulerView extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        refresh: 60000
    };

    protected eventColumns = [{
            width: 15
        }, {
            width: 25,
            Cell: (props: any) => this.buttonRenderer(props)
        }, {
            Header: 'Event',
            accessor: 'name',
            width: 300,
            headerStyle: { textAlign: 'center'},
            sortable: true,
            Cell: (props: any) => this.nameRenderer(props.value)
        }, {
            Header: 'Start',
            accessor: 'schedule.startTime',
            width: 180,
            headerStyle: { textAlign: 'left' },
            sortable: true,
            Cell: (props: any) => Renderers.timestamp.format(props.value)
        }, {
            Header: 'End',
            accessor: 'schedule',
            width: 200,
            headerStyle: { textAlign: 'left' },
            sortable: true,
            Cell: (props: any) => this.endTimeRenderer(props.value)
        }, {
            Header: 'Duration',
            accessor: 'schedule.duration',
            width: 150,
            headerStyle: { textAlign: 'left' },
            sortable: true,
            Cell: (props: any) => Renderers.timestamp.duration(props.value)
        }, {
            Header: 'Start Window (mins)',
            accessor: 'schedule.startWindow',
            width: 170,
            headerStyle: { textAlign: 'left' },
            sortable: true
        }, {
            Header: 'URL',
            accessor: 'url',
            width: 600,
            headerStyle: { textAlign: 'left' },
            sortable: true,
            resizable: false,
            Cell: (props: any) => this.urlRenderer(props.value)
        }, {
            Header: 'Alarm Template',
            accessor: 'template',
            width: 200,
            headerStyle: { textAlign: 'left' },
            sortable: true,
            resizable: false
        }
    ];

    private updateTimer: number;

    componentWillMount() {
        this.setState({
            showImportModal: false,
            showDeleteModal: false,
            showResultModal: false,
            modalText: '',
            file: null,
            indices: [],
            renderingComplete: false,
            filteredDailyData: false,
            filteredEventData: false,
            assetFilter: '',
            eventFilter: '',
            revision: 'A',
            dailyTabSelected: true,
            startDateFilter: '',
            selectedDay: '',
            defaultSelectedDay: '',
            dayOfWeek: '',
            startTicks: 0,
            endTicks: 0
        });
        this.calculateIndices = this.calculateIndices.bind(this);
        this.cellRenderer = this.cellRenderer.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.fetchDailyData = this.fetchDailyData.bind(this);
        this.fetchEventData = this.fetchEventData.bind(this);
        this.getTimeOfDay = this.getTimeOfDay.bind(this);
        this.handleImportModalClose = this.handleImportModalClose.bind(this);
        this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);
        this.handleResultModalClose = this.handleResultModalClose.bind(this);
    }

    componentDidMount() {
        let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        // Your moment
        let mmt = moment();
        let day = days[ mmt.day() ];

        this.setState({
            selectedDay: day,
            defaultSelectedDay: day
        });
    }

    componentWillUnmount() {
        if (this.updateTimer !== null)
            clearTimeout(this.updateTimer);
    }

    gotoInterval (interval: any) {
        let element = document.getElementById(interval.toString());
        if (element) {
            element.scrollIntoView();
        }
    }

    getSysName(oauth: OAuthClientStatus) {
        let now = new Date();
        let url = '';
        let sysName = (oauth.sys.name ? oauth.sys.name : 'surveyor-abr');
        // sysName = encodeURIComponent(sysName);

        url += sysName + '-';
        url += (now.getFullYear() + ('0' + (now.getUTCMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2));

        return url;
    }

    import(activate: string) {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let formData = new FormData();
        formData.append('schType', activate);
        formData.append('fileData', this.state.file);

        axios.put('http://default/api/schedule/daily', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    __this.fetchDailyData(false);
                    __this.handleImportModalClose();
                    __this.setState({selectedDay: __this.state.defaultSelectedDay});
                } else
                    throw response;
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('expected daily schedule, got ', error);
                __this.setState({selectedDay: __this.state.defaultSelectedDay});
            });
    }

    export(oauth: OAuthClientStatus, option: number) {
        // tslint:disable-next-line:variable-name
        let __this = this;

        if (option === 1) {
            axios.get('http://default/api/schedule/daily/export?schType=0')
                .then(function (response: AxiosResponse) {

                    if (response.data) {
                        let stringObject = response.data;
                        fileDownload(stringObject, 'IQSchedule_' + __this.getSysName(oauth) + '.txt');
                    } else
                        throw response;

                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('expected daily schedule, got ', error);
                });
        } else {
            axios.get('http://default/api/schedule/daily/template')
                .then(function (response: AxiosResponse) {

                    if (response.data) {
                        let stringObject = response.data;
                        fileDownload(stringObject, 'IQScheduleTemplate_' + __this.getSysName(oauth) + '.txt');
                    } else
                        throw response;

                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('expected schedule template, got ', error);
                });
        }
    }
    deleteAllEvents() {
        axios.delete('http://default/api/schedule/event?events=all')
            .then((response: AxiosResponse) => {
            if ((response.data !== undefined) && (response.data.code === 'SUCCESS')) {
                this.setState({ showDeleteModal: false, showResultModal: true, modalText: 'Events Deleted.' });
                this.fetchEventData(false); // fetch data right away
            }
        }).catch((error: AxiosRequestConfig) => {
            this.setState({ deleteAll: false, showDeleteModal: false, showResultModal: true, modalText: 'Delete Operation Failed.' });
        });
    }
    deleteEvent(data: any) {
        let url = 'http://default/api/schedule/event?events=name&name=' + data.row.name;
        axios.delete(url)
            .then((response: AxiosResponse) => {
                if ((response.data !== undefined) && (response.data.code === 'SUCCESS')) {
                    this.setState({ showDeleteModal: false, showResultModal: true, modalText: 'Event Deleted.' });
                    this.fetchEventData(false); // fetch data right away
                }
            }).catch((error: AxiosRequestConfig) => {
            this.setState({ deleteAll: false, showDeleteModal: false, showResultModal: true, modalText: 'Delete Operation Failed.' });
        });
    }
    scheduleNextUpdate(ms ?: number) {
        if (this.updateTimer !== null) clearTimeout(this.updateTimer);
        if (ms === undefined) {
            ms = this.props.refresh;
        }
        this.updateTimer = setTimeout(() => this.fetchData(), ms);
    }
    getTimeOfDay() {
        // Figure out what minute of the day we are in.
        // Your moment
        let mmt = moment();
        // Your moment at midnight
        let mmtMidnight = mmt.clone().startOf('day');
        // Difference in minutes
        let minute = mmt.diff(mmtMidnight, 'minutes');
        let interval = Math.floor(minute / 15);
        if (interval < 95) {
            interval++;
        }
        let secs = minute * 2;
        this.setState ({
            minuteOfDay: minute,
            secIntervalOfDay: secs,
            intervalOfDay: interval
        });
    }
    fetchData() {
        // tslint:disable-next-line:no-console
        // console.log('FetchData...');
        this.state.filteredDailyData ? this.fetchDailyData(true) : this.fetchDailyData(false);
        this.state.filteredEventData ? this.fetchEventData(true) : this.fetchEventData(false);
        this.scheduleNextUpdate();
    }
    getTicks(timeStr: string) {
        // convert time passed in to ticks
        let parts = timeStr.split(/:+/gi);
        let hrs = parseInt(parts[0], 10) * 120; // 30 sec intervals * 4 (15 min bins) = 1 hr
        let mins = parseInt(parts[1], 10) * 2;  // 30 sec intervals

        return hrs + mins;
    }
    fetchDailyData(filterOperation: boolean) {
        // tslint:disable-next-line:no-console
        // console.log('fetch Daily Data');
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/schedule/daily';
        if (!filterOperation) {
            axios.get(url)
                .then(function (response: AxiosResponse) {
                    if (response.data !== undefined) {
                        if (response.data.code === 'SUCCESS') {
                            if (response.data.dailySchedule.file.revision === 'A') {
                                __this.setState({
                                    dailyData: response.data.dailySchedule.schedule,
                                    revision: 'A',
                                    dayOfWeek: 'N/A',
                                    startTicks: response.data.dailySchedule.plan.startTime ? __this.getTicks(response.data.dailySchedule.plan.startTime) : 0,
                                    endTicks: response.data.dailySchedule.plan.endTime ? __this.getTicks(response.data.dailySchedule.plan.endTime) : 0,
                                    timeTicks: response.data.dailySchedule.plan.timeTicks,
                                    unFilteredDailyData: response.data.dailySchedule.schedule,
                                    fileName: response.data.dailySchedule.file.name,
                                    creationTime: response.data.dailySchedule.file.creationTime
                                },              () => __this.calculateIndices('A')
                                );
                            } else {
                                __this.setState({
                                    dailyData: response.data.dailySchedule.schedule,
                                    revision: 'B',
                                    dayOfWeek: response.data.dailySchedule.schedule.dayOfWeek,
                                    timeTicks: 1440,
                                    unFilteredDailyData: response.data.dailySchedule.schedule,
                                    fileName: response.data.dailySchedule.file.name,
                                    creationTime: response.data.dailySchedule.file.creationTime
                                },              () => __this.calculateIndices('B')
                                );
                            }
                            // figure out where to display the current time slot marker
                            __this.getTimeOfDay();
                            // scroll to right as page refreshes
                            __this.gotoInterval(__this.state.intervalOfDay);
                            // filter data based on selected day/default day
                            if (response.data.dailySchedule.file.revision === 'A') {
                                __this.filterSchedule('', 'N/A');
                            } else {
                                __this.filterSchedule('', __this.state.selectedDay);
                            }
                        } else
                            // tslint:disable-next-line:no-console
                            console.log('expected array of streams, got ', response.data);
                    } else
                        // tslint:disable-next-line:no-console
                        console.log('expected array of streams, got ', response.data);
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('scheduler fetchDailyData() error: ', error);
                });
        }
    }

    fetchEventData(filterOperation: boolean) {
        // tslint:disable-next-line:no-console
        // console.log('fetch Event Data');
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/schedule/event';
        if (!filterOperation) {
            // axios.get(url, {headers: {'x-orderby': 'order events by name'}})
            axios.get(url)
                .then(function (response: AxiosResponse) {
                    if (response.data !== undefined) {
                        // tslint:disable-next-line:no-debugger
                        __this.setState({
                            eventData: response.data.events,
                            unFilteredEventData: response.data.events
                        });
                    } else
                        // tslint:disable-next-line:no-console
                        console.log('expected array of streams, got ', response.data);
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('scheduler fetchEventData() error: ', error);
                });
        }
    }
    handleImportModalClose() {
        this.setState({
            showImportModal: false
        });
    }
    handleDeleteModalClose() {
        this.setState({
            showDeleteModal: false
        });
    }
    handleResultModalClose() {
        this.setState({
            showResultModal: false,
            deleteAll: false
        });
    }
    calculateIndices(type: String) {
        // let planArr = this.state.data.filter((asset: any) => asset.alias === row.original.alias).map((asset: any) => asset.plan);
        // Getting all the indices to be marked
        let indicesObject = []; let timeTicks = this.state.timeTicks;
        for (let asset of this.state.dailyData) {
            if (type === 'A' || asset.bitlist === undefined) {
                let toBeMatchedIndices = [], newArray = [];
                // in case there are multiple sets of data returned in plan. e.g. ["1-660", "700-2880"]
                let sets = asset.plan.split(',');
                for (let x = 0; x < sets.length; x++) {
                    let planRange = sets[x].split('-');
                    let startIndex = parseInt(planRange[0], 10), endIndex = parseInt(planRange[1], 10);
                    for (let i = startIndex; i <= endIndex; i++) {
                        toBeMatchedIndices.push(i);
                    }
                }
                for (let i = 0; i < toBeMatchedIndices.length; i++) {
                    // SAN-5415: Start/End Time provided.
                    let sum = this.state.startTicks !== 0 ? toBeMatchedIndices[i] + this.state.startTicks : toBeMatchedIndices[i];
                    let endTicks = this.state.endTicks !== 0 ? this.state.endTicks : 2880;
                    newArray.push(sum);

                    while (sum <= endTicks) {
                        sum += timeTicks;
                        if (sum <= endTicks) newArray.push(sum);
                    }
                }
                let aliasPresent = indicesObject.find( a => a.name === asset.alias );
                /* indicesObject contains the alias already */
                if (aliasPresent !== undefined) {
                    aliasPresent.value.push(...newArray);
                } else {
                    let aliasObject: any = {};
                    aliasObject.name = asset.alias;
                    aliasObject.value = newArray;
                    indicesObject.push(aliasObject);
                }
            } else { // type === 'B'
                let newArray = [];
                let wholeString = '';
                let individualString;

                for (let i = 0; i < asset.bitlist.length; i++) {
                    // convert decimal number to binary number
                    // console.log('parseInt: ' + parseInt(asset.bitlist[i], 10).toString(2));
                    individualString = asset.bitlist[i].toString(2);
                    // pad with zeros to get 15 numbers (1 minute intervals)
                    individualString = individualString.padStart(15, '0');
                    // build whole array of 1440 numbers
                    wholeString = wholeString.concat(individualString);
                }

                // convert to an array of 1440 numbers.
                const numericList = Array.from(wholeString.split('')).map(item => Number(item));
                // just include time slots that are scheduled
                for (let i = 0; i < 1440; i++) {
                    if (numericList[i] === 1) {
                        newArray.push(i + 1);
                    }
                }

                let aliasPresent = indicesObject.find( a => a.name === asset.alias );
                /* indicesObject contains the alias already */
                if (aliasPresent !== undefined) {
                    aliasPresent.value.push(...newArray);
                } else {
                    let aliasObject: any = {};
                    aliasObject.name = asset.alias;
                    aliasObject.value = newArray;
                    indicesObject.push(aliasObject);
                }
            }
        }

        this.setState({
            indices: indicesObject
        });

    }
    cellRenderer(row: any, start: number, end: number, interval: number): React.ReactNode {
        let indents = [];
        let toBeMatchedIndices;
        let matchingArr = this.state.indices.filter((asset: any) => asset.name === row.original.alias);
        if (matchingArr[0] !== undefined)
            toBeMatchedIndices = matchingArr[0].value;
        let highlight = interval === 30 ? this.state.secIntervalOfDay : this.state.minuteOfDay;
        for (let i = start; i < end; i++) {
            let cssClass;
            if (highlight === i) {
                cssClass = 'chicklet-span blank-span time-marker';
            } else {
                cssClass = 'chicklet-span blank-span';
            }

            if (matchingArr[0] !== undefined) {
                if (toBeMatchedIndices.includes(i)) {
                    if (highlight === i) {
                        cssClass = 'chicklet-span scheduled-span time-marker';
                    } else {
                        cssClass = 'chicklet-span scheduled-span';
                    }
                }
                indents.push(<span key={'' + i} className={cssClass}/>);
            }
        }

        return (
            <div
                style={{
                    width: '100%',
                    height: '8px',
                    backgroundColor: 'transparent',
                    borderRadius: '2px',
                    transition: 'all .2s ease-out'
                }}
            >
                {indents}
            </div>
        );
    }
    getDailyColumns() {
        let columns = [];
        let header = [
            '00:00', '00:15', '00:30', '00:45', '01:00', '01:15', '01:30', '01:45', '02:00', '02:15', '02:30', '02:45',
            '03:00', '03:15', '03:30', '03:45', '04:00', '04:15', '04:30', '04:45', '05:00', '05:15', '05:30', '05:45',
            '06:00', '06:15', '06:30', '06:45', '07:00', '07:15', '07:30', '07:45', '08:00', '08:15', '08:30', '08:45',
            '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45',
            '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45',
            '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45',
            '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45', '20:00', '20:15', '20:30', '20:45',
            '21:00', '21:15', '21:30', '21:45', '22:00', '22:15', '22:30', '22:45', '23:00', '23:15', '23:30', '23:45'
        ];
        columns.push(
            {
                Header: 'Alias',
                accessor: 'alias',
                headerStyle: {'textAlign': 'center'},
                width: 360,
                headerClassName: 'sticky-column',
                className: 'sticky-column',
                sortable: false,
                resizable: false,
                Cell: (props: any) => this.aliasNameRenderer(props.value)
            }
        );
        if (this.state.revision === 'A') {
            for (let i = 0; i < 96; i++) {
                let start = (i * 30) + 1;
                let end = start + 30;

                columns.push({
                    Header: (h: any) => <span id={i.toString()}>{header[i]}</span>,
                    headerStyle: { textAlign: 'center'},
                    width: 365,
                    sortable: false,
                    resizable: false,
                    Cell: (row: any) => this.cellRenderer(row, start, end, 30)
                }, );
            }
        } else { // revision 'B'
            for (let i = 0; i < 96; i++) {
                let start = (i * 15) + 1;
                let end = start + 15;

                columns.push({
                    Header: (h: any) => <span id={i.toString()}>{header[i]}</span>,
                    headerStyle: { textAlign: 'center'},
                    width: 185,
                    sortable: false,
                    resizable: false,
                    Cell: (row: any) => this.cellRenderer(row, start, end, 60)
                }, );
            }
        }

        return columns;
    }
    filterAlias(alias: any) {
        const regexp = new RegExp(alias, 'i');
        this.setState({
          dailyData: this.state.dailyData.filter((asset: any) => regexp.test(asset.alias))
        });
    }
    filterSchedule(alias: any, day: any) {
        if (alias !== '' && day === 'N/A') {
            const regexp = new RegExp(alias, 'i');
            this.setState({
                assetFilter: alias,
                filteredDailyData: true,
                dailyData: this.state.unFilteredDailyData.filter((asset: any) => regexp.test(asset.alias))
            });
        } else if (alias === '' && day === 'N/A') {
            this.setState({
                assetFilter: '',
                filteredDailyData: false,
                dailyData: this.state.unFilteredDailyData
            });
        } else if (alias === '' && day !== 'N/A') {
            const regexp = new RegExp(day, 'i');
            this.setState({
                assetFilter: '',
                selectedDay: day,
                filteredDailyData: true,
                dailyData: this.state.unFilteredDailyData.filter((asset: any) => regexp.test(asset.dayOfWeek))
            });
        } else if (alias !== '' && day !== 'N/A') {
            let regexp = new RegExp(alias, 'i');
            let data = this.state.unFilteredDailyData.filter((asset: any) => regexp.test(asset.alias));
            regexp = new RegExp(day, 'i');
            this.setState({
              assetFilter: alias,
              selectedDay: day,
              filteredDailyData: true,
              dailyData: data.filter((asset: any) => regexp.test(asset.dayOfWeek))
            });
            // }), this.filterAlias(alias);
        }
    }
    filterEvent(event: any, startDate: any) {
        const regexp = new RegExp(event, 'i');
        let startTime = 0;
        if (startDate === null) startDate = '';
        if (startDate !== '') {
            startTime = moment(startDate).startOf('minute').unix();
        }
        if (event !== '' && startDate === '') {
            this.setState({
                eventFilter: event,
                startDateFilter: '',
                filteredEventData: true,
                eventData: this.state.unFilteredEventData.filter((asset: any) => regexp.test(asset.name))
            });
        } else if (event === '' && startDate === '') {
            this.setState({
                eventFilter: '',
                startDateFilter: '',
                filteredEventData: false,
                eventData: this.state.unFilteredEventData
            });
        } else if (event === '' && startDate !== '') {
            this.setState({
                eventFilter: '',
                startDateFilter: startDate,
                filteredEventData: true,
                eventData: this.state.unFilteredEventData.filter((asset: any) => asset.schedule.startTime >= startTime)
            });
        } else if (event !== '' && startDate !== '') {
            let data = this.state.unFilteredEventData.filter((asset: any) => regexp.test(asset.name));
            this.setState({
              eventFilter: event,
              startDateFilter: startDate,
              filteredEventData: true,
                eventData: data.filter((asset: any) => asset.schedule.startTime >= startTime)
            });
            // }), this.setState({
            //       eventData: this.state.eventData.filter((asset: any) => asset.schedule.startTime >= startTime)
            //     });
        }
    }
    render() {
        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        const { name, startDateFilter, dailyTabSelected, revision } = this.state;
        const panes = [
            { menuItem: 'Daily'}, { menuItem: 'Event'}
        ];

        const exportOptions = [
            { key: 1, text: 'Current Schedule', value: 1 },
            { key: 2, text: 'Blank Template', value: 2 }
        ];

        const dayOptions = [ { value: 'Monday', text: 'Monday' },
            {  value: 'Tuesday', text: 'Tuesday' }, { value: 'Wednesday', text: 'Wednesday' }, { value: 'Thursday', text: 'Thursday' },
            { value: 'Friday', text: 'Friday' }, { value: 'Saturday', text: 'Saturday' }, { value: 'Sunday', text: 'Sunday' } ];
        
        return (
            <div className="view-content" id="txlog">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Scheduler</div>
                        </div>
                    </div>
                </div>
                {dailyTabSelected ?
                <div className="filterPanel">
                    < Input
                        className="filterPanelSearchBox"
                        placeholder="Alias"
                        value={this.state.assetFilter}
                        onChange={(event: any, data: { value: string; }) => revision === 'A' ? this.filterSchedule(data.value as string, 'N/A') : this.filterSchedule(data.value as string, this.state.selectedDay)}
                        icon={!this.state.assetFilter ? <Icon /> : <Icon name="delete" link onClick={() => revision === 'A' ? this.filterSchedule('', 'N/A') : this.filterSchedule('', this.state.selectedDay)} />}
                    />
                    {revision === 'B' ?
                        <Dropdown
                            className="alarmLogDropDown"
                            search
                            selection
                            options={dayOptions}
                            value={this.state.selectedDay}
                            onChange={(event, data) => this.filterSchedule(this.state.assetFilter, data.value)}
                        />
                    : ''}
                    <Label className="right-align-label-width120"/>
                    <div className="iq-scheduler-key-val">
                        <div className="iq-scheduler-key">Schedule Name</div>
                        <div className="iq-scheduler-val"> {this.state.fileName ? this.state.fileName : '-'}</div>
                    </div>
                    <Label className="right-align-label-width120"/>
                    <div className="iq-scheduler-key-val">
                        <div className="iq-scheduler-key">Creation Time</div>
                        <div className="iq-scheduler-val"> {this.state.creationTime ? this.state.creationTime : '-'}</div>
                    </div>
                    <Button
                        className="filter-panel-rightButton"
                        title="Import Scheduler File"
                        content="Import"
                        onClick={() => this.setState({showImportModal: true})}
                    />
                    <OAuth.Context>{(oauth: OAuthClientStatus) => (
                        <div className="exportDropdown">
                            <Dropdown
                                className="filter-panel-rightButton"
                                text="Export"
                                selectOnBlur={false}
                                button
                                direction="left"
                                options={exportOptions}
                                value={this.state.exportData}
                                onChange={(event, data) => { if (data.value) { this.export(oauth, data.value as number); this.setState({exportData: data.text}); }}}
                            />
                        </div>
                    )}</OAuth.Context>
                </div> :
                    <div className="filterPanel">
                        < Input
                            className="filterPanelSearchBox"
                            value={this.state.eventFilter}
                            placeholder="Event"
                            onChange={(event: any, data: { value: string; }) => this.filterEvent(data.value as string, this.state.startDateFilter)}
                            icon={!this.state.eventFilter ? <Icon /> : <Icon name="delete" link onClick={() => this.filterEvent('', this.state.startDateFilter)} />}
                        />
                        <DatePicker
                            className="datePicker1SearchBox"
                            // todayButton={'Today'}
                            placeholderText={'Start Time'}
                            selected={startDateFilter}
                            value={this.state.startDateFilter ? moment(this.state.startDateFilter).format('LLL') : undefined}
                            onChange={(date, event) => this.filterEvent(this.state.eventFilter, date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={30}
                            dateFormat="LLL"
                            isClearable={this.state.startDateFilter ? true : false}
                        />
                        <Button
                            className="filter-panel-rightButton"
                            title="Purge Events"
                            content="Delete All"
                            onClick={() => this.setState({showDeleteModal: true, deleteAll: true})}
                            icon={<Icon name="trash alternate outline" link onClick={() => this.setState({showDeleteModal: true, deleteAll: true})} />}
                        />
                    </div> }
                <Tab menu={{ secondary: true, pointing: true }} panes={panes} defaultActiveIndex={0} onTabChange={(event: any, data: any) => this.changeTab(data)}/>
                <div className="view-clientarea">
                    <ReactTable
                        className="overflow-body transaction-log -striped -highlight"
                        onFetchData={() => this.fetchData()}
                        data={(this.state && dailyTabSelected) ? this.state.dailyData : this.state.eventData}
                        columns={dailyTabSelected ? this.getDailyColumns() : this.eventColumns}
                        defaultPageSize={16}
                        PaginationComponent={CustomPagination}
                        noDataText={'No monitoring events are currently scheduled'}
                        defaultSorted={ dailyTabSelected ?
                            [
                            {
                                id: 'alias',
                                asc: true
                            }
                        ] : [
                            {
                                id: 'schedule.startTime',
                                asc: true
                            }
                        ] }
                    />
                    <Modal
                        open={this.state.showImportModal}
                        onClose={() => this.handleImportModalClose()}
                        size="mini"
                        style={inlineStyle.modal}
                    >
                    <Modal.Header>Import Schedule File</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                <Input
                                    placeholder="Enter the Alias"
                                    type="file"
                                    onChange={(e: any) => this.setState({file: e.target.files[0]})}
                                />
                            </Form.Field>
                            <Form.Group grouped className="align-center">
                                <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.import('0')}>
                                    Import & Activate Now
                                </Button>
                            </Form.Group>
                            <Form.Group grouped className="align-center">
                                <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.import('1')}>
                                    Import Now & Activate at Midnight
                                </Button>
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-secondary-btn modal-button-padding" onClick={() => this.handleImportModalClose()}>
                            Cancel
                        </Button>
                    </Modal.Actions>
                    </Modal>

                    <Modal
                        open={this.state.showDeleteModal}
                        onClose={() => this.handleDeleteModalClose()}
                        size="mini"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header>{this.state.deleteAll ? 'Delete All Events' : 'Delete Event'} </Modal.Header>
                        {/* tslint:disable-next-line:max-line-length */}
                        <Modal.Content>{this.state.deleteAll ? 'This operation will delete all the scheduled events from the probe. Do you want to continue?' : 'This operation will delete the scheduled event from the probe. Do you want to continue?'}</Modal.Content>
                        <Modal.Actions>
                            <Button className="filterPanel-secondary-btn modal-button-padding" onClick={() => this.state.deleteAll ? this.deleteAllEvents() : this.deleteEvent(name)}>
                                Yes
                            </Button>
                            <Button className="filterPanel-secondary-btn modal-button-padding" onClick={() => this.handleDeleteModalClose()}>
                                Cancel
                            </Button>
                        </Modal.Actions>
                    </Modal>

                    <Modal
                        style={inlineStyle.modal}
                        open={this.state.showResultModal}
                        onClose={this.handleResultModalClose}
                        size="mini"
                    >
                        <Modal.Header>{this.state.deleteAll ? 'Delete All Events' : 'Delete Event'} </Modal.Header>
                        <Modal.Content>{this.state.modalText}</Modal.Content>
                        <Modal.Actions>
                            <Button onClick={this.handleResultModalClose}>OK</Button>
                        </Modal.Actions>
                    </Modal>
                </div>
            </div>
        );
    }
    buttonRenderer(name: any): React.ReactNode {
        return (
            <div className="cellIcons">
                <Button
                    className="grid-hamburger-menu-button iconSpacing"
                    title="Delete Event"
                    onClick={(event, data) => this.setState({showDeleteModal: true, deleteAll: false, name: name})}
                >
                    <FontAwesome name="fas fa-trash-o"/>
                </Button>
            </div>
        );
    }

    aliasNameRenderer(value: any) {
        return (
            <div title={value} style={{ textAlign: 'center' }}>
                {value.substring(0, 50)}
            </div>);
    }

    nameRenderer(value: any) {
        return (
            <div style={{ textAlign: 'center' }}>
                {value}
            </div>);
    }

    endTimeRenderer(props: any) {
        let startTime = props.startTime;
        let duration = props.duration;
        let endTime = startTime + duration;

        endTime = Renderers.timestamp.format(endTime);

        return endTime;
    }

    tooltipRenderer() {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={250} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }

    urlRenderer(value: any) {
        return (
            <div data-tip={value} className="text-wrap">
                {value}
                {this.tooltipRenderer()}
            </div>);
    }

    changeTab(data: any) {
        if (data.activeIndex === 1) {
            this.setState({dailyTabSelected: false}, () => {
                // callback
                // tslint:disable-next-line:no-console
                console.log(this.state.dailyTabSelected);
            });
            // tslint:disable-next-line:no-console
            // console.log('Event tab selected');
        }  else if (data.activeIndex === 0) {
            this.setState({dailyTabSelected: true}, () => {
                // callback
                // tslint:disable-next-line:no-console
                console.log(this.state.dailyTabSelected);
            });
            // tslint:disable-next-line:no-console
            // console.log('Daily tab selected');
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/monitoring/scheduler.tsx